var _rect, _circle, _path, _path2, _line, _line2, _line3, _rect2, _rect3, _path3, _path4, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle4, _circle5, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _path5, _path6, _path7, _path8, _rect14, _rect15, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsiteTechinicalScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 81,
    width: 199,
    height: 199,
    rx: 24,
    stroke: "#192657",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 194,
    r: 80,
    stroke: "#F58120",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205 194C205 216.256 200.822 236.357 194.109 250.856C187.358 265.438 178.232 274 168.5 274C158.768 274 149.642 265.438 142.891 250.856C136.178 236.357 132 216.256 132 194C132 171.744 136.178 151.643 142.891 137.144C149.642 122.562 158.768 114 168.5 114C178.232 114 187.358 122.562 194.109 137.144C200.822 151.643 205 171.744 205 194Z",
    stroke: "#F58120",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.5 230.5C146.244 230.5 126.143 226.322 111.644 219.609C97.0616 212.858 88.5 203.732 88.5 194C88.5 184.268 97.0616 175.142 111.644 168.391C126.143 161.678 146.244 157.5 168.5 157.5C190.756 157.5 210.857 161.678 225.356 168.391C239.938 175.142 248.5 184.268 248.5 194C248.5 203.732 239.938 212.858 225.356 219.609C210.857 226.322 190.756 230.5 168.5 230.5Z",
    stroke: "#F58120",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 168,
    y1: 275,
    x2: 168,
    y2: 113,
    stroke: "#F58120",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 193,
    x2: 250,
    y2: 193,
    stroke: "#F58120",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 69,
    y1: 107,
    x2: 270,
    y2: 107,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 92,
    width: 40,
    height: 6,
    rx: 3,
    fill: "#528FF5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 92,
    width: 101,
    height: 6,
    rx: 3,
    fill: "#528FF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131 95C131 93.3431 132.343 92 134 92C135.657 92 137 93.3431 137 95C137 96.6569 135.657 98 134 98C132.343 98 131 96.6569 131 95Z",
    fill: "#528FF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141 95C141 93.3431 142.343 92 144 92C145.657 92 147 93.3431 147 95C147 96.6569 145.657 98 144 98C142.343 98 141 96.6569 141 95Z",
    fill: "#528FF5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 268,
    r: 31,
    stroke: "#192657",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 268,
    r: 21,
    fill: "#528FF5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 228,
    width: 20,
    height: 11,
    fill: "#192657"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 296.537,
    y: 240.079,
    width: 20,
    height: 11,
    transform: "rotate(60.9255 296.537 240.079)",
    fill: "#192657"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 305.51,
    y: 281.889,
    width: 20,
    height: 11,
    transform: "rotate(122.59 305.51 281.889)",
    fill: "#192657"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 298,
    width: 20,
    height: 11,
    fill: "#192657"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 235.357,
    y: 274.096,
    width: 20,
    height: 11,
    transform: "rotate(60.9255 235.357 274.096)",
    fill: "#192657"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 246.531,
    y: 244.185,
    width: 20,
    height: 11,
    transform: "rotate(122.59 246.531 244.185)",
    fill: "#192657"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 21.163,
    transform: "matrix(1 0 0 -1 291.257 199.779)",
    stroke: "#192657",
    strokeWidth: 4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 14.7401,
    transform: "matrix(1 0 0 -1 291.256 199.779)",
    fill: "#528FF5"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 14.0382,
    height: 7.72101,
    transform: "matrix(1 0 0 -1 284.236 227.855)",
    fill: "#192657"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 14.0382,
    height: 7.72101,
    transform: "matrix(0.485946 -0.873989 -0.873989 -0.485946 312.689 219.377)",
    fill: "#192657"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 14.0382,
    height: 7.72101,
    transform: "matrix(-0.538623 -0.842547 -0.842547 0.538623 318.988 190.03)",
    fill: "#192657"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 14.0382,
    height: 7.72101,
    transform: "matrix(1 0 0 -1 284.236 178.721)",
    fill: "#192657"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 14.0382,
    height: 7.72101,
    transform: "matrix(0.485946 -0.873989 -0.873989 -0.485946 269.748 195.5)",
    fill: "#192657"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 14.0382,
    height: 7.72101,
    transform: "matrix(-0.538623 -0.842547 -0.842547 0.538623 277.59 216.495)",
    fill: "#192657"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89 46L91.9187 54.9828H101.364L93.7225 60.5344L96.6412 69.5172L89 63.9656L81.3588 69.5172L84.2775 60.5344L76.6363 54.9828H86.0813L89 46Z",
    fill: "#F58120"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119 46L121.919 54.9828H131.364L123.723 60.5344L126.641 69.5172L119 63.9656L111.359 69.5172L114.277 60.5344L106.636 54.9828H116.081L119 46Z",
    fill: "#F58120"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149 46L151.919 54.9828H161.364L153.723 60.5344L156.641 69.5172L149 63.9656L141.359 69.5172L144.277 60.5344L136.636 54.9828H146.081L149 46Z",
    fill: "#F58120"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M179 49.2361L180.968 55.2918L181.192 55.9828H181.919H188.286L183.135 59.7254L182.547 60.1525L182.771 60.8435L184.739 66.8992L179.588 63.1565L179 62.7295L178.412 63.1565L173.261 66.8992L175.229 60.8435L175.453 60.1525L174.865 59.7254L169.714 55.9828H176.081H176.808L177.032 55.2918L179 49.2361Z",
    stroke: "#192657",
    strokeWidth: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 234,
    width: 53,
    height: 6,
    rx: 3,
    fill: "#F58120"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 247,
    width: 37,
    height: 6,
    rx: 3,
    fill: "#F58120"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M282 176C304.333 158.5 344.8 144.6 328 229C322.5 284.5 292 374.6 214 291C116.5 186.5 373.5 47.0002 197 36.0002C20.4998 25.0002 -35.0006 219 89.4996 305.5",
    stroke: "black",
    strokeDasharray: "2 2 2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteTechinicalScore);
export default __webpack_public_path__ + "static/media/WebsiteTechinicalScore.4fd94cfc90b95581325f906358969ab6.svg";
export { ForwardRef as ReactComponent };